// Imports
import React from 'react';
import styled from 'styled-components/macro';
import { StylingProps, styling } from './standard';
import { Link, LinkProps } from 'react-router-dom';


// A Link component that's styled like a button
const LinkButton = styled(
	// eslint-disable-next-line react/display-name
	React.forwardRef<HTMLAnchorElement, Omit<StylingProps & LinkProps, 'type'>>(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		({ color, inverted, border, link, smaller, smallest, isLoading, useBackgroundColorWithFocus, ...props }, ref) => (
			<Link {...props} ref={ref} />
		)
	)
)`
	${styling}
`;

export default LinkButton;
